import { useCallback, useState, useEffect } from 'react'

import { useKeydown } from '~/hooks/useKeyDown'

export const useListArrows = (
  listLength: number,
  disabled?: boolean,
): {
  currentFocus: number
  resetFocus: () => void
  setFocus: (index: number) => void
} => {
  const [currentFocus, setCurrentFocus] = useState(0)

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (disabled) return
      if (e.key === 'ArrowDown') {
        // Down arrow
        e.preventDefault()
        setCurrentFocus(currentFocus === listLength - 1 ? 0 : currentFocus + 1)
      } else if (e.key === 'ArrowUp') {
        // Up arrow
        e.preventDefault()
        setCurrentFocus(currentFocus === 0 ? listLength - 1 : currentFocus - 1)
      }
    },
    [disabled, currentFocus, listLength],
  )

  useKeydown(handleKeyDown)

  useEffect(() => {
    setCurrentFocus(0)
  }, [listLength])

  const resetFocus = useCallback(() => setCurrentFocus(0), [setCurrentFocus])

  const setFocus = useCallback(
    (index: number) => setCurrentFocus(index),
    [setCurrentFocus],
  )

  return { currentFocus, resetFocus, setFocus }
}
